import { render, staticRenderFns } from "./TestDataEditor.vue?vue&type=template&id=fc9b8852&scoped=true&"
import script from "./TestDataEditor.vue?vue&type=script&lang=js&"
export * from "./TestDataEditor.vue?vue&type=script&lang=js&"
import style0 from "./TestDataEditor.vue?vue&type=style&index=0&id=fc9b8852&scoped=true&lang=css&"
import style1 from "./TestDataEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9b8852",
  null
  
)

export default component.exports